'use client';

import dynamic from 'next/dynamic';

const ChatBot = dynamic(
  () =>
    import('./(main)/store/components/chatbot/chatbot').then((m) => ({
      default: m.ChatBot,
    })),
  { ssr: false }
);
const ContactFormButton = dynamic(
  () => import('./(main)/store/components/items/contact-form-toggle'),
  { ssr: false }
);
const ScrollToTopButton = dynamic(
  () => import('./(main)/store/components/scroll-to-top-button'),
  { ssr: false }
);
const DebugPanel = dynamic(
  () =>
    import('@/lib/debug/debug-panel').then((m) => ({ default: m.DebugPanel })),
  { ssr: false }
);
const StoreCityIdSheetManager = dynamic(
  () =>
    import('@/components/store-city-sheet-manager').then((m) => ({
      default: m.StoreCityIdSheetManager,
    })),
  { ssr: false }
);
const NavigationWrapper = dynamic(
  () =>
    import('@/components/navigation/navigation-wrapper').then((m) => ({
      default: m.NavigationWrapper,
    })),
  { ssr: false }
);
const GlobalLoginDialog = dynamic(
  () =>
    import('@/components/auth/global-login-dialog').then((m) => ({
      default: m.GlobalLoginDialog,
    })),
  { ssr: false }
);

export default function LazyUI() {
  return (
    <>
      <ScrollToTopButton />
      <ContactFormButton />
      <ChatBot />
      <NavigationWrapper />
      <StoreCityIdSheetManager />
      <GlobalLoginDialog />
      <DebugPanel />
    </>
  );
}
